import i18n from '@/utils/i18n';
import React from 'react';
import { AppPageLayout } from '@experiences/templates/app-page-layout';
import { ProspectFinderContent } from '@/experiences/sales-portal/domain/prospects/screens/prospect-finder/containers/prospect-finder-content';
import { SALES_PORTAL_ROUTES } from '@/navigators/routes';
import { SalesHubShellTemplate } from '@/experiences/sales-portal/templates/sales-hub-shell-template';
import { SalesPortalStackParams } from '@/navigators/types';
import { StackScreenProps } from '@react-navigation/stack';

type Props = StackScreenProps<
  SalesPortalStackParams,
  typeof SALES_PORTAL_ROUTES.ProspectFinder
>;

export const ProspectFinderScreen: React.FC<Props> = ({ route }) => {
  const { supplierUUID } = route.params;

  return (
    <SalesHubShellTemplate>
      <AppPageLayout
        scroll={false}
        title={i18n.t('sales_portal.sidebar.prospects')}
      >
        <ProspectFinderContent supplierUUID={supplierUUID} />
      </AppPageLayout>
    </SalesHubShellTemplate>
  );
};
